import { booleanAttribute, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClSelect } from '@corelabs/angular/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { ErrorComponent } from '../error/error.component';
import { FormOption } from '../form-option.type';

@Component({
    selector: 'app-form-select',
    templateUrl: './form-select.component.html',
    styleUrls: ['./form-select.component.css'],
    imports: [ReactiveFormsModule, ClSelect, ErrorComponent, TranslatePipe],
})
export class FormSelectComponent<T> {
    readonly control = input.required<FormControl<T>>();
    readonly label = input<string>('');
    readonly options = input.required<FormOption<T>[]>();
    readonly inputId = input.required<string>();
    readonly placeholder = input<string>('');
    readonly filter = input(false, { transform: booleanAttribute });
    readonly loading = input(false, { transform: booleanAttribute });
}
